export default __webpack_public_path__ + "static/media/ic-brickwall.81aa2622.svg";